import request from '../utils/request'

const prefix = '/api/v1/back'

/**
 * 内容推荐部分
 *
 */



/**
 * 推荐查询：列表
 * @param {*} query
 */
export const recommendList = (query) => {
  return request({
    url: `${prefix}/recommend/list`,
    method: 'get',
    params: query
  })
}

/**
 * 推荐查询
 * @param {*} query
 */
export const recommendOne = (query) => {
  return request({
    url: `${prefix}/recommend`,
    method: 'get',
    params: query
  })
}

/**
 * 推荐创建
 * @param {*} query
 */
export const recommendCreate = (query) => {
  return request({
    url: `${prefix}/recommend`,
    method: 'post',
    data: query
  })
}

/**
 * 推荐修改
 * @param {*} query
 */
export const recommendUpdate = (query) => {
  return request({
    url: `${prefix}/recommend`,
    method: 'put',
    data: query
  })
}

/**
 * 推荐删除
 * @param {*} query
 */
export const recommendDestroy = (query) => {
  return request({
    url: `${prefix}/recommend`,
    method: 'delete',
    data: query
  })
}


/**
 * 推荐位置查询：列表
 * @param {*} query
 */
export const recommendPositionList = (query) => {
  return request({
    url: `${prefix}/recommend/position/list`,
    method: 'get',
    params: query
  })
}

/**
 * 推荐位置查询
 * @param {*} query
 */
export const recommendPositionOne = (query) => {
  return request({
    url: `${prefix}/recommend/position`,
    method: 'get',
    params: query
  })
}

/**
 * 推荐位置创建
 * @param {*} query
 */
export const recommendPositionCreate = (query) => {
  return request({
    url: `${prefix}/recommend/position`,
    method: 'post',
    data: query
  })
}

/**
 * 推荐位置修改
 * @param {*} query
 */
export const recommendPositionUpdate = (query) => {
  return request({
    url: `${prefix}/recommend/position`,
    method: 'put',
    data: query
  })
}

/**
 * 推荐位置删除
 * @param {*} query
 */
export const recommendPositionDestroy = (query) => {
  return request({
    url: `${prefix}/recommend/position`,
    method: 'delete',
    data: query
  })
}
